import React from 'react';
import classnames from "classnames";

const Box = props => {
  return <div className={classnames(props.className, props.widthClassName)}>
    {props.children}
  </div>
}

Box.defaultProps = {
  widthClassName: "",
}

export default Box;